export default __webpack_public_path__ + "static/media/avatar.5d697394.jpg";